import React from 'react';

const Items = (props) => {
  const item = props.item;

  return (
    <div className="Item">
      <label htmlFor={props.label} className = "item-label">{item.label}</label>
      <div className="wrap-itemContens">

          {item.contents.map(content => {
            switch(content.type){
              case "number" : {
                return  <div className="wrap-input" key = {content.id}>
                          <input 
                            type = {content.type}
                            name = {content.name}
                            id = {content.id}
                            value = {content.value}
                            onChange = {props.onChange(props.docName, item.label)}
                          />
                        </div> 
              }

              case "text" : {
                return  <div className="wrap-input" key = {content.id}>
                          <input 
                            type = {content.type}
                            name = {content.name}
                            id = {content.id}
                            value = {content.value}
                            onChange = {props.onChange}
                          />
                        </div> 
              }

              case "file" : {
                return  <div className="wrap-fileImage" key = {content.id}>
                          <input 
                            type = {content.type}
                            name = {content.name}
                            id = {content.id}
                            onChange = {props.onChange(props.docName, item.label)}
                          />
                          <label htmlFor={content.id}>
                            <div className="dim">
                              <p>파일 변경</p>
                            </div>
                            <img src={content.url} alt={content.name}/>
                          </label>
                        </div> 
              }

              default : {
                return "";
              }
            }
            
          })}
       
      </div>
    </div>
  );
}

export default Items;